var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as NewsActions from '../../actions/news';
var initialState = {
    fetching: false,
    news: []
};
export default function newsReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) { //eslint-disable-line default-case
        case NewsActions.GET_NEWS:
            return __assign(__assign({}, state), { fetching: true });
        case NewsActions.SUCCESS_GET_NEWS:
            return __assign(__assign({}, state), { fetching: true, news: action.data });
        case NewsActions.FAILURE_GET_NEWS:
            return __assign(__assign({}, state), { fetching: false });
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/news/newsReducer.js